export default "__VITE_ASSET__BDkf2WWr__"